import { ENV_LOCAL, ENV_DEV } from './env';

let backendHost = 'https://arth-e-api.openium.fr';
const apiVersion = 'v1';

if (process.env.REACT_APP_ENV) {
  if (process.env.REACT_APP_ENV === ENV_LOCAL) {
    backendHost = 'http://localhost:8180';
  } else if (process.env.REACT_APP_ENV === ENV_DEV) {
    backendHost = 'https://arth-e-api-dev.openium.fr';
  }
}

const API_ROOT = `${backendHost}/api/${apiVersion}`;
export default API_ROOT;
